import { ApplicationCoverageStatusScreen } from "@/interactors/ApplicationCoverageStatusScreen";

export default function CoverageStatus() {
  return <ApplicationCoverageStatusScreen />;
}
